import { Box, TextField } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCGState } from "../customerGroupSetupSlice";

export default function CreateComments() {
	const cgState = useSelector((store) => store.customerGroupSetup);
	const { createComments } = cgState;
	const dispatch = useDispatch();

	function updateComments(event) {
		const comment = event.target.value;
		dispatch(setCGState("createComments", comment));
	}

	return (
		<Box sx={{ mt: 2 }}>
			<TextField
				className={"fullHeight fullWidth"}
				overflow="scroll"
				multiline
				id="outlined-basic"
				label=""
				rows={6}
				variant="outlined"
				size="large"
				// InputProps={{ sx: { height: sizes.w150 } }}
				value={createComments}
				onChange={updateComments}
				InputProps={{ autoComplete: "off" }}
			/>
		</Box>
	);
}
